export default __webpack_public_path__ + "b02c1a7c66e8cdb8789f0bf0f17e42cb.png";